/* @flow */
// typecheck: ignore file
import React from 'react';
import { graphql } from 'react-apollo';
import invariant from 'invariant';
import gql from 'graphql-tag';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

type Props = {
  error?: Object,
  district?: {| id: number |},
  school?: {| id: number |},
  schoolRedirect?: boolean,
  districtRedirect?: boolean,
};

class AdminIndex extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.invariants();
  }

  componentWillReceiveProps(nextProps: Props) {
    this.invariants();

    const errorChanged = !this.props.error && nextProps.error;

    if (errorChanged) {
      this.context.router.push({ pathname: 'error' });
      return;
    }

    const goToDistrict = (id: number) => {
      this.context.router.push({ pathname: `admin/districts/${id}` });
    };

    const goToSchool = (id: number) => {
      this.context.router.push({ pathname: `admin/schools/${id}` });
    };

    const { school, district } = nextProps;

    if (!school && !district) {
      console.error('AdminIndex error: School or district not found');
      this.context.router.push({ pathname: 'error' });
      return;
    }

    if (school && this.props.schoolRedirect) {
      goToSchool(school.id);
      return;
    }

    if (district && this.props.districtRedirect) {
      goToDistrict(district.id);
      return;
    }

    if (district) {
      goToDistrict(district.id);
    } else if (school) {
      goToSchool(school.id);
    } else {
      this.context.router.push({ pathname: 'error' });
    }
  }

  invariants() {
    invariant(!this.props.schoolRedirect || !this.props.districtRedirect, 'error can only be school or district');
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}

const withAdministratedOrganizations = graphql(gql`
  query {
    me {
      id
      districts: organizations(first: 1, type: "district", affiliation_status: [admin pending_admin]) {
        id
      }
      schools: organizations(first: 1, type: "school", affiliation_status: [admin pending_admin]) {
        id
      }
    }
  }
  `,
  {
    props: ({ data }) => ({
      district: data.me ? data.me.districts[0] : null,
      school: data.me ? data.me.schools[0] : null,
      ...data,
    }),
  }
);

export { AdminIndex };
export default withAdministratedOrganizations(AdminIndex);



// WEBPACK FOOTER //
// ./src/admin/routeHandlers/AdminIndex.jsx